import { Typography } from '@capsule/consumer-design-system';

import Button from 'src/app/components/Elements/Button';

import styles from '../styles.module.scss';

interface CheckoutCardSectionProps {
  refillsRemaining: number;
  removeFromCart: () => void;
  displayNamePrimary: string;
  addToCart: () => void;
  insuranceApplied?: boolean;
  price: string;
  isInCart: boolean;
  showRefillCount: boolean;
  showPrice: boolean;
  showAddToBag?: boolean;
}

export const CheckoutSection = ({
  removeFromCart,
  displayNamePrimary,
  addToCart,
  isInCart,
  insuranceApplied,
  price,
  showAddToBag = true,
  showPrice,
}: CheckoutCardSectionProps) => {
  return (
    <div className={showPrice ? styles.priceArea : styles.hiddenPriceArea}>
      {/*If showAddToBag is True, we want to show the add to bag button. If showAddTobag is True and showPrice is True, we want to show the price*/}
      <div className={styles.price}>
        {showAddToBag && showPrice && (
          <>
            {insuranceApplied && (
              <Typography className={styles.insurance} variant="small" color="capsuleGray50">
                Price with insurance
              </Typography>
            )}
            <div className="title-2">{price}</div>
          </>
        )}
      </div>
      {showAddToBag && (
        <div>
          {isInCart ? (
            <Button
              style="secondary"
              size="small"
              onClick={removeFromCart}
              data-cy={`in-bag-${displayNamePrimary.split(' ').join('-')}`}
              aria-label={`Remove ${displayNamePrimary} from bag`}
            >
              In Bag
            </Button>
          ) : (
            <Button
              style="primary"
              size="small"
              onClick={addToCart}
              data-cy={`add-to-bag-${displayNamePrimary.split(' ').join('-')}`}
              aria-label={`Add ${displayNamePrimary} to bag`}
            >
              Add To Bag
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
